import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { Box, Stack, Drawer,IconButton } from '@mui/material';
import { styled,  } from '@mui/material/styles';
// hooks
import useResponsive from '../../../hooks/useResponsive';
// config
import { NAV, HEADER } from '../../../config-global';

// components
import Scrollbar from '../../../components/scrollbar';
import { NavSectionVertical } from '../../../components/nav-section';
//
import navConfig from './config-navigation';
import NavAccount from './NavAccount';
import Iconify from '../../../components/iconify';
import AppCache from '../../../services/appcache';

// ----------------------------------------------------------------------
const StyledLogo = styled('div')(({ theme }) => ({
    width: NAV.W_DASHBOARD,
    height: HEADER.H_DASHBOARD_DESKTOP,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2, 2.5),
    backgroundColor: theme.palette.primary.main,
}));
// --------------------------------------------------------------------------
NavVertical.propTypes = {
    openNav: PropTypes.bool,
    onOpenNav: PropTypes.bool,
    onCloseNav: PropTypes.func,
    navWidth: PropTypes.number,
};

export default function NavVertical({ openNav, onOpenNav, onCloseNav, navWidth }) {
    const { pathname } = useLocation();
    const isDesktop = useResponsive('up', 'lg');

    const IsRedirect = AppCache.GetIsRedirect();

    const hideShow = sessionStorage.getItem('hideShow') === 'true';    


    useEffect(() => {
        if (IsRedirect === '1') { 
            onCloseNav();
        } else if (!hideShow && isDesktop && openNav) {
            onOpenNav();
        } else {
            onCloseNav();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname, IsRedirect]);




    const renderContent = (
        <Scrollbar
            sx={{
                height: 0.96,
                '& .simplebar-content': {
                    height: 1,
                    display: 'flex',
                    flexDirection: 'column',
                },
            }}
        >
            <Stack
                spacing={1}
                sx={{
                    // pt: 3,
                    pb: 0.5,
                     
                    // px: 2.5,
                    flexShrink: 0,
                }}
            >
                {/* <Logo /> */}
                
                <NavAccount />
            </Stack>

            <Scrollbar
                sx={{
                    height: 1,
                    '& .simplebar-content': {
                        height: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        // spacing:0
                    },
                }}
            >
                <NavSectionVertical data={navConfig} />
            </Scrollbar>
            <Box sx={{ flexGrow: 1 }} />

            { /*  <NavDocs /> */}
        </Scrollbar>
    );

    return (
        <Box
            component="nav"
            sx={{
                flexShrink: { lg: 0 },
                width: { lg:navWidth },
            }}
        >
            {/* <NavToggleButton /> */}
            {isDesktop && openNav &&
                <IconButton
                    sx={{
                        p: 0.5,
                        top: 32,
                        position: 'fixed',
                        left: NAV.W_DASHBOARD - 12,
                        bgcolor: 'background.default',
                        zIndex: (theme) => theme.zIndex.appBar + 1,
                        border: (theme) => `dashed 1px ${theme.palette.divider}`,
                        '&:hover': {
                            bgcolor: 'background.default',
                        },
                    }}
                    onClick={onCloseNav}
                >
                    <Iconify width={16} icon='eva:arrow-ios-back-fill' />
                </IconButton>
            }
            {isDesktop ? (
                <Drawer
                    open={openNav}
                    onClose={onCloseNav}
                    variant="permanent"
                    PaperProps={{
                        sx: {
                            zIndex: 0,
                            width: navWidth,
                            bgcolor: '#f7f7fa',
                            borderRightStyle: 'dashed',
                        },
                    }}
                >
                    {renderContent}
                </Drawer>
            ) : (
                <Drawer
                    open={openNav}
                    onClose={onCloseNav}
                    ModalProps={{
                        keepMounted: true,
                    }}
                    PaperProps={{
                        sx: {
                            width: navWidth,
                        },
                    }}
                >
                    {renderContent}
                </Drawer>
            )}
        </Box>
    );
}
